export var LinkContextMenuOptions;
(function (LinkContextMenuOptions) {
    /// Open the link in new tab
    LinkContextMenuOptions[LinkContextMenuOptions["OpenInNewTab"] = 0] = "OpenInNewTab";
})(LinkContextMenuOptions || (LinkContextMenuOptions = {}));
export default function getLinkContextMenuOptions() {
    return Object.keys(LinkContextMenuOptions)
        .filter(function (value) { return !isNaN(Number(LinkContextMenuOptions[value])); })
        .map(function (key) { return LinkContextMenuOptions[key]; });
}
//# sourceMappingURL=LinkContextMenuOptions.js.map